import React from "react";
import { SvgIcon } from "@material-ui/core";


export default function BackIcon(): JSX.Element {
    return (
        <SvgIcon viewBox="0 0 28 43">
            <path d="M23.2195 43L28 37.625L10.9268 21.5L28 4.70312L23.2195 0L0 21.5L23.2195 43Z" fill="orange" />
        </SvgIcon>
    );
}
